module.exports = __webpack_public_path__ + "static/media/footage.1d406343.svg";